import { HiOutlineLightBulb } from "react-icons/hi";
import { RiAiGenerate2 } from "react-icons/ri";

const Solutions = () => {
  return (
    <div className="w-full">
      <div className="flex items-center justify-between mb-4 sticky top-0 bg-white z-10 py-2">
        <div className="flex items-center gap-2">
          <HiOutlineLightBulb className="w-6 h-6" />
          <h5 className="text-xl font-bold">Solutions</h5>
        </div>
        <RiAiGenerate2 className="w-6 h-6 cursor-pointer hover:text-blue-500" />
      </div>
      <div className="bg-white rounded-lg p-4">
        <p className="text-base">
          This is where you can view and manage solutions for the problems.
        </p>
      </div>
    </div>
  );
};

export default Solutions;
